// extracted by mini-css-extract-plugin
export var pillWrapper = "_y9-0";
export var showOverflow = "_y9-1";